export default __webpack_public_path__ + "static/media/BLANK ENDO Boarding Form (Macomb and Oakland).8e9dc3bd.pdf";